(() => {
  const OPTION_LABELS = {
    o_2370663: 'Metal',
    o_2370664: 'Carat Weight',
    o_2370665: 'Diamond Origin',
    o_2370666: 'Ring Size'
  };

  let quoteDetails = '';

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function getVisibleValue(field) {
    if (field.tagName === 'SELECT') {
      return clean(field.options[field.selectedIndex]?.text);
    }

    const relatedLabel = field.id
      ? document.querySelector(`label[for="${CSS.escape(field.id)}"]`)
      : null;

    const wrapper =
      relatedLabel ||
      field.closest(
        'label, .mw-option__value, .mw-option__value-container, [class*="option__value"]'
      );

    const image = wrapper?.querySelector(
      'img.mw-option__swatch-image[alt]'
    );

    if (image?.alt) {
      return clean(image.alt);
    }

    const visibleText = wrapper?.querySelector(
      '.mw-option__value-text'
    );

    if (visibleText?.textContent) {
      return clean(visibleText.textContent);
    }

    return clean(field.value);
  }

  function getSelectedOptions() {
    const container = document.querySelector(
      '#mw-apo-app-block, .mw-apo-container'
    );

    if (!container) return [];

    const options = new Map();

    container
      .querySelectorAll(
        'select, input:checked, input[type="text"], input[type="number"]'
      )
      .forEach((field) => {
        if (field.disabled) return;

        const optionId = field.name?.match(/o_\d+/)?.[0];
        const label = OPTION_LABELS[optionId];

        if (!label) return;

        const value = getVisibleValue(field);

        if (
          !value ||
          value.toLowerCase().includes('please select')
        ) {
          return;
        }

        options.set(label, value);
      });

    return Array.from(options.entries());
  }

  function buildMessage() {
    const productTitle = clean(
      document.querySelector(
        'h1, .product-title, [data-product-title]'
      )?.textContent
    );

    return [
      `Product: ${productTitle}`,
      ...getSelectedOptions().map(
        ([label, value]) => `${label}: ${value}`
      )
    ].join('\n');
  }

const QUOTE_BUTTON =
  '.cfp-prod-button, .cfp-prod-wrapper-detail button, .cfp-prod-wrapper-detail a';

const REQUIRED_OPTIONS = [
  'Metal',
  'Carat Weight',
  'Diamond Origin',
  'Ring Size'
];

function getMissingOptions() {
  const selected = new Map(getSelectedOptions());

  return REQUIRED_OPTIONS.filter(
    (option) => !selected.get(option)
  );
}

function updateQuoteButton() {
  const button = document.querySelector(QUOTE_BUTTON);
  if (!button) return;

  const missing = getMissingOptions();
  const wrapper =
    button.closest('.cfp-prod-wrapper-detail') ||
    button.parentElement;

  let notice = document.querySelector(
    '.local-forge-quote-notice'
  );

  if (!notice && wrapper) {
    notice = document.createElement('div');
    notice.className = 'local-forge-quote-notice';
    notice.style.marginTop = '10px';
    notice.style.fontSize = '12px';
    notice.style.color = '#7a3e32';
    wrapper.insertAdjacentElement('afterend', notice);
  }

  if (missing.length) {
    button.style.pointerEvents = 'none';
    button.style.opacity = '0.45';
    button.setAttribute('aria-disabled', 'true');

    if (notice) {
      notice.textContent =
        'Please complete all required selections before requesting a quote.';
      notice.style.display = 'block';
    }
  } else {
    button.style.pointerEvents = '';
    button.style.opacity = '';
    button.removeAttribute('aria-disabled');

    if (notice) {
      notice.style.display = 'none';
    }
  }
}

document.addEventListener(
  'change',
  () => requestAnimationFrame(updateQuoteButton),
  true
);

document.addEventListener('click', (event) => {
  if (
    event.target.closest(
      '#mw-apo-app-block, .mw-apo-container'
    )
  ) {
    requestAnimationFrame(updateQuoteButton);
  }
});

setTimeout(updateQuoteButton, 500);
setTimeout(updateQuoteButton, 1500);

/* Populate the message after SB handles a valid click */
document.addEventListener('click', (event) => {
  if (!event.target.closest(QUOTE_BUTTON)) return;
  if (getMissingOptions().length) return;

  quoteDetails = buildMessage();

  const populateWhenVisible = () => {
    const fields = [
      ...document.querySelectorAll(
        'textarea.sb-cfp2ms-textarea'
      )
    ];

    const field = fields.find(
      (item) => item.getClientRects().length > 0
    );

    if (!field) return false;

    field.value = quoteDetails;
    return true;
  };

  if (populateWhenVisible()) return;

  const observer = new MutationObserver(() => {
    if (populateWhenVisible()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true
  });

  setTimeout(() => observer.disconnect(), 2000);
});

})();